export default __webpack_public_path__ + "static/media/enterpriseGdpr.6d8793b6.svg";